<template>
  <div>
    <AuditHero />
    <Audit1 />
    <Audit2 />
    <Audit3 />
  </div>
</template>

<script>
import AuditHero from '@/components/Audit/AuditHero.vue'
import Audit1 from '@/components/Audit/Audit1.vue'
import Audit2 from '@/components/Audit/Audit2.vue'
import Audit3 from '@/components/Audit/Audit3.vue'

export default {
  name: 'Audit',
  components: {
    AuditHero,
    Audit1,
    Audit2,
    Audit3,
  },
  props: {
    auditChecked: {
      type: Boolean,
    },
  },
}
</script>
